// UQ-nl-BE
module.exports = {
  "forTest": "test for UQ-nl-BE",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Officiële styling",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Sorteren op",
  "text_filter": "Filter",
  "text_styling_book_search_results_number": "{total} resultaten",
  "text_active_filters": "Actieve filters",
  "text_styling_book_clear_all_filters": "Alles wissen",
  "text_styling_book_search_by_feature": "Zoeken op functie",
  "text_styling_book_search_by_category": "Zoeken op categorie",
  "text_styling_book_staff_customer_filter_all": "Alle",
  "text_styling_book_search_by_coordinate": "Zoeken op keyword",
  "text_styling_book_staff_customer_filter_title": "Gepost door",
  "text_styling_book_search_by_height": "Zoeken op lengte",
  "text_styling_book_search_by_hashtag": "Zoeken op hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Klanten",
  "text_styling_book_staff_customer_filter_staff_styling": "UNIQLO medewerkers",
  "text_apply_search_filter": "Toepassen",
  "text_styling_book_no_results": "Geen resultaten",
  "text_error_title": "Service tijdelijk niet beschikbaar",
  "text_503_error_description-1": "Excuses, er is een fout opgetreden.",
  "text_503_error_description-2": "Probeer het later opnieuw of ga terug naar de vorige pagina.",
  "text_503_error_instruction": "Neem bij eventuele vragen contact met ons op via de Contact-pagina.",
  "text_styling_book_go_to_top": "UNIQLO Homepage",
  "text_contactus": "Contact opnemen",
  "text_wishlist": "Wishlist",
  "text_membership_info": "Mijn Account",
  "text_wearing_items": "Shop de look",
  "text_color": "Kleur",
  "text_size": "Maat",
  "text_stylehint_non_listed_items_message_01": "*Producten die niet worden weergegeven, zijn niet beschikbaar.",
  "text_styling_book_related_styling_title": "Gerelateerde looks",
  "text_style_styling_date_update": "Updaten",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} €",
  "text_404": "Pagina niet gevonden",
  "text_official_styling_top_page_link": "Officiële styling homepage",
  "text_stylehint_top_page_link": "StyleHint homepage",
  "text_breadcrumbs_top": "UNIQLO homepage",
  "text_a11y_close": "Sluiten",
  "text_log_in": "Inloggen",
  "text_app_update_dialog_cancel": "Annuleren",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Alle rechten voorbehouden.",
  "text_stylehintapp": "StyleHint-app",
  "text_styling_book_official_styling_page_title": "Officiële styling",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Nieuwste items",
  "text_styling_book_sort_popular": "Meest populair",
  "text_styling_book_search_by_color": "Zoeken op kleur",
  "text_filter_clear_all_category": "Alle categorieën wissen",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Alle tonen",
  "text_error_description": "Er is een systeemfout opgetreden. Probeer het opnieuw of kom later terug.",
  "text_system_error": "Systeemfout",
  "text_ok": "OK",
  "text_login_required": "Inloggen vereist",
  "text_login_request": "Ga naar de inlogpagina.",
  "text_error_failed_sort_product": "Kan producten niet sorteren op de geselecteerde criteria. Pas sorteren opnieuw toe.",
  "text_error_failed_update_filter_criteria": "Kon de filtercriteria niet bijwerken. Probeer het opnieuw.",
  "text_meta_title_postfix": "| UNIQLO BE",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Dames",
  "text_styling_book_meta_men": "Heren",
  "text_styling_book_meta_kids": "Kids",
  "text_styling_book_meta_baby": "Baby",
  "text_styling_book_official_gender_meta_description": "Ontdek ons lookbook en vind de perfecte {gender} stijlen van het seizoen! Shop de hele look of voeg je favorieten toe aan je wishlist om later te shoppen.",
  "text_styling_book_official_gender_meta_title": "Ontdek seizoenslooks | {gender} | Officiële styling {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender} 「{filterOptions}」stylingideeën {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Ontdek stylingideeën voor {gender} 「{filterOptions}」 met items van {brand}. Ontdek de vele stylingmogelijkheden.",
  "text_styling_book_official_detail_meta_title": "Shop looks voor「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Bekijk de nieuwste 「{officialProducts}」van dit seizoen en shop de hele look nu op {brand}.com!",
  "text_styling_book_stylehint_gender_meta_title": "Ontdek nieuwe styling- en outfitideeën | {geslacht} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Doe outfitinspiratie op! Bekijk {gender} stylingideeën van onze klanten en medewerkers van {brand} die via de StyleHint-app zijn geplaatst.",
  "text_styling_book_stylehint_filter_meta_title": "{gender} 「{filterOptions}」stylingideeën {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Outfit-ideeën van {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Outfit-ideeën van {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Outfit-ideeën van {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Bekijk stylingideeën voor「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Bekijk {brand}{storeName})'s medewerker {staffName}({height} {styleHint}. Kijk hoe het personeel looks creëert met on-trend items.",
  "text_styling_book_stylehint_ins_user_meta_description": "Bekijk Instagram-gebruiker 「{userName}」{styleHint} die {merk} mode-items gebruikt om de outfit te mixen-en-matchen. Bekijk andere gebruikers en zie hoe zij outfits stylen met on-trend items.",
  "text_styling_book_stylehint_customer_user_meta_description": "Ontdek outfitideeën van {userName} ({height}) met on-trend items van {brand}. Bekijk alle items die getoond worden in de online store.",
  "text_styling_book_stylehint_detail_meta_description": "Ontdek nieuwe stijlen voor 「{stylehintProducts}」van onze klanten en het personeel van {brand}. Shop de hele look nu op {brand}.com!",
  "text_styling_book_stylehint_filter_meta_description": "Ontdek 「{searchCount}」outfitideeën van「{filterOptions}」 met behulp van modeartikelen van {brand}. Bekijk de nieuwe collecties & trendartikelen in de online winkel.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} LOOKBOOK{styleHint} Style ID: <{styleid}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} LOOKBOOK{styleHint} Style ID: <{styleid}>",
  "text_styling_book_official_detail_id_alt_tag": "Ontdek stylingideeën van 「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Ontdek de outfitideeën van 「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Outfit-ideeën van {gender} 「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Stylingideeën van {gender}「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Het spijt ons. Er is een fout opgetreden. Ga later naar deze site of ga terug naar de vorige pagina met de terugknop van de browser.",
  "text_styling_book_meta_official_styling": "Stylingideeën",
  "text_styling_book_meta_stylehint": "Outfit-ideeën",
  "text_limited_offer_until_date": "Tijdelijke aanbieding tot {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Online-exclusive aanbieding geldig tot {date}",
  "text_app_membership_exclusive_limited_offer_until": "Alleen voor app-members tot {date}",
  "text_csoon_early": "Verkrijgbaar vanaf {month}",
  "text_csoon_mid": "Verkrijgbaar vanaf midden {month}",
  "text_csoon_late": "Verkrijgbaar vanaf eind {month}",
  "text_men": "Heren",
  "text_women": "Dames",
  "text_kids": "Kids",
  "text_baby": "Baby",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "Alleen voor app-member",
  "text_styling_book_gender_menu_kids_and_baby": "Kids/Baby",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Toevoegen aan wishlist",
  "text_close": "Sluiten",
  "text_error_wishlist_max": "Je kunt het artikel niet aan je wishlist toevoegen vanwege het overschrijden van het maximum van 999 artikelen.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Geen afbeelding",
  "text_wearing_size_code01": "Draagt maat: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "Français",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "Nederlands",
  "text_product_unavailable": "Dit product is uit productie.",
  "text_product_display_markdown": "",
  "text_color_white": "Wit",
  "text_color_gray": "Grijs",
  "text_color_black": "Zwart",
  "text_color_pink": "Roze",
  "text_color_red": "Rood",
  "text_color_orange": "Oranje",
  "text_color_beige": "Beige",
  "text_color_brown": "Bruin",
  "text_color_yellow": "Geel",
  "text_color_green": "Groen",
  "text_color_blue": "Blauw",
  "text_color_purple": "Paars",
  "text_promotion": "Aanbieding",
  "text_styling_promotion_hashtag": "Promotie",
  "text_coming_soon": "Binnenkort verkrijgbaar",
  "text_markdown": "Korting",
  "text_multibuy_markdown": "Multi-buy, korting",
  "text_multibuy_limited_offer_until_date": "Multi-buy, tijdelijke aanbieding geldig tot {date}",
  "text_app_membership_exclusive_multi_buy_until": "Multi-Buy Online & App-Only Aanbieding tot {date}",
  "text_app_membership_exclusive_multi_buy": "Multi-Buy Online & App-Only Aanbieding",
  "text_app_membership_exclusive_limitedoffers_until": "Online & App-Only Aanbieding tot {date}",
  "text_item_preorder_color_size_only": "Reserveren & Bezorgen (selecte kleuren en maten)",
  "text_item_resale_color_size_only": "Back in stock (selecte kleuren / maten)"
}; // generated at Tue Jul 29 2025 17:10:23 GMT+0800 (Hong Kong Standard Time)